
import EventPublisher from "../utils/EventPublisher";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


export default class FileUploadAPIClient {
    constructor() {
        this.submitAdvertisementResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("IMAGE_UPLOAD_URL_CREATED", this.onImageUploadURLCreated));
    }

    createFileUploadUrl(image) {
        SecureRequestExecuter.executePOSTRequest(
            "/api/private/image_upload_url",
            {},
            {
                "image_extension": image.name.split(".").pop()
            },
            {
                "image": image
            },
            this.submitAdvertisementResponseHandler
        );
    }

    uploadFile(url, image, fields, name) {
        const fd = new FormData();
        for (const field in fields) {
            if (fields.hasOwnProperty(field)) {
                fd.append(field, fields[field]);
            }
        }
        fd.append("file", image);

        fetch(
            url,
            {
                method: "POST",
                mode: "cors",
                body: fd,
            }).then(
            (response) => {
                EventPublisher.publish(
                    ActionResultEvents.IMAGE_UPLOAD_FINISHED,
                    {
                        "image": image,
                        "imageName": name,
                    });
            }).catch(
            (reason) => {
                console.error(reason);
            }
        );
    }

    onImageUploadURLCreated = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.IMAGE_UPLOAD_URL_CREATED, {"image": dataFromAction.image});
        this.uploadFile(
            responseBodyContents["url"],
            dataFromAction.image,
            responseBodyContents["fields"],
            responseBodyContents["name"]);
    };

}